import DataTable from 'datatables.net-responsive-bs5';
import $ from "jquery";
import axios from 'axios';

class HorseTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.table = self.elem.querySelector('[data-table]');
        self.toggleColumn = $(self.table).find('[data-column-toggle]');
        self.toggleColumnIndex = self.toggleColumn.index();

        self.ajaxTemplate = self.table.getAttribute('data-ajax-template') ?? null;
    }

    init() {
        let self = this;

        let dataTable = new DataTable(self.table, {
            paging: false,
            info: false,
            searching: false,
            columnDefs: [
                { targets: 'no-sort', orderable: false },
            ],
            responsive: {
                breakpoints: [
                    { name: 'xxl', width: Infinity },
                    { name: 'xl', width: 1400 },
                    { name: 'lg', width: 1200 },
                    { name: 'md', width: 992 },
                    { name: 'sm', width: 768 },
                    { name: 'xs', width: 576 }
                ],
                details: {
                    'type': false,
                    target: self.toggleColumnIndex
                }
            },
        });

        // Add event listener for opening and closing horse details dropdown panel
        dataTable.on('click', '[data-horse-details-control]', function (evt) {            
            let tr = evt.target.closest('tr');
            let row = dataTable.row(tr);
            let horseId = tr.getAttribute('data-horse-id');

            if (row.child.isShown()) {
                // This row is already open - close it
                $('[data-horse-details-panel]', row.child()).slideUp(200, function () {
                    row.child.hide();
                });
            }
            else {
                if(!tr.hasAttribute('data-has-been-open') && self.ajaxTemplate) {
                    axios.get(`/ajax/${self.ajaxTemplate}?horseId=${horseId}`)
                        .then(function (response) {
                            // Populate with data and assign class to td
                            row.child(response.data, [
                                'horses-table__details'
                            ]).show();

                            $('[data-horse-details-panel]', row.child()).slideDown(200);

                            tr.setAttribute('data-has-been-open', '1');
                        })
                        .catch(function (error) {
                            // handle error
                            console.log(error);
                        });
                } else {
                    row.child.show();
                    $('[data-horse-details-panel]', row.child()).slideDown(200);
                }
            }
        });
    }
}

export default HorseTable;